import { DatePipe } from '@angular/common';
import { ElementRef, Input, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ButtonOption } from 'src/app/components/datatable/datatablecolumn/datatablecolumn.component';
import { Question } from 'src/app/services/settings/forms.service';
import { LabelPreparationService, LabelPreparationSetup } from 'src/app/services/settings/labelpreparation.service';
import { QRCodeSetup } from 'src/app/services/settings/qrcode.service';
import { AsyncModalService } from 'src/app/services/shared/async-modal-service';
import { LabelPreparationForm } from './label-preparation.form.component';

declare var bootstrap: any;

@Component({
    standalone: false,
    selector: 'app-labelpreparation-register',
    templateUrl: './label-preparation.register.component.html',
    styleUrls: ['./label-preparation.register.component.css']
})
export class LabelPreparationRegister implements OnInit {

    @ViewChild("labelPreparationSetupModalButton") labelPreparationSetupModalButton: ElementRef;
    @ViewChild("labelPreparationSetupForm") labelPreparationSetupForm: LabelPreparationForm;
    @Input() labelPreparationFormQuestions: Question[];
    @Input() labelPreparationHeaderCoreQuestions: any[];
    
    labelPreparationSetup: LabelPreparationSetup;
    labelPreparationRegister: any[];
    showLabelPreparationSetupModal: boolean;
    formId: number;
    loading: boolean;
    isViewMode: boolean;
    isEditMode: boolean;

    constructor(
        private route: ActivatedRoute,
        private asyncModalService: AsyncModalService,
        private labelPreparationService: LabelPreparationService
    ) {

    }

    ngOnInit(): void {
        this.formId = 0;
        this.loading = false;
        this.isViewMode = false;
        this.isEditMode = false;
        this.showLabelPreparationSetupModal = false;
        this.labelPreparationRegister = [];

        let params = this.route.snapshot.params;
        if (params["id"]) {
            this.formId = +params["id"];
            this.labelPreparationService.formEntryNumber = this.formId;
        }

        this.labelPreparationService.formArea = this.route.snapshot.data.formArea;
        this.labelPreparationSetup = new LabelPreparationSetup();
        this.refreshTable();
    }

    addLabelPreparationSetup() {
        if (this.formId) {
            this.labelPreparationSetup = new LabelPreparationSetup();
            this.showLabelPreparationSetupModal = true;
            this.isViewMode = false;
            this.isEditMode = false;
            this.labelPreparationSetupModalButton.nativeElement.click();
        }
    }

    onSaveLabelPreparationSetupForm() {
        this.refreshTable();
    }

    onCloseLabelPreparationSetupModal() {
        this.showLabelPreparationSetupModal = false;

        // Bootstrap 5's own close cleanup (hiding the element, removing the
        // backdrop, resetting body state) waits on a CSS transitionend event
        // that doesn't fire reliably once Angular's *ngIf tears down the
        // modal's content around the same time - a Bootstrap 5 behavior
        // change (Bootstrap 4, used before the upgrade, needed none of this).
        // Rather than race that unreliable event with a timer, the close
        // buttons no longer carry data-bs-dismiss - this handler is now the
        // sole, synchronous owner of closing the modal: it tears everything
        // down directly and disposes the Modal instance immediately, so
        // there's nothing left pending and no delay of any kind is needed.
        const modalElement = document.getElementById("labelpreparation-form");

        if (modalElement) {
            modalElement.classList.remove("show");
            modalElement.style.display = "none";
            modalElement.setAttribute("aria-hidden", "true");
            modalElement.removeAttribute("aria-modal");
            modalElement.removeAttribute("role");

            if (typeof bootstrap !== "undefined") {
                bootstrap.Modal.getInstance(modalElement)?.dispose();
            }
        }

        if (!document.querySelector(".modal.show")) {
            document
                .querySelectorAll(".modal-backdrop")
                .forEach((backdrop) => backdrop.remove());
            document.body.classList.remove("modal-open");
            document.body.style.removeProperty("overflow");
            document.body.style.removeProperty("padding-right");
        }
    }

    private refreshTable() {
        if (this.formId > 0) {
            this.loading = true;
            this.labelPreparationService.getAll().subscribe(
                (data) => {
                    this.labelPreparationRegister = [];
                    this.labelPreparationRegister = data;
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    this.asyncModalService.getModalResponse(err.error);
                },
                () => {
                    this.setLabelPreparationSetupRegister();
                    this.loading = false;
                })
        }
    }

    private setLabelPreparationSetupRegister() {
        (this.labelPreparationRegister || []).forEach((entity) => {
            entity.name = entity.name;
            entity.lastUpdated = new DatePipe("en-US").transform(
                entity.modified?.toString() ?? entity.created?.toString(), "yyyy-MM-dd HH:mm"
            ),
                entity.lastUpdatedBy = (
                    entity.modifiedBy != "" ? entity.modifiedBy : entity.createdBy ?? ""
                ),
                entity.status = entity.isActive ? "Active" : "Inactive";
            entity.options = [
                {
                    value: "Edit",
                    controller: this,
                    click: (controller: LabelPreparationRegister) => {
                        this.edit(controller, entity)
                    },
                },
                {
                    value: "View",
                    controller: this,
                    click: (controller: LabelPreparationRegister) => {
                        this.view(controller, entity);
                    },
                },
                {
                    value: entity.status == "Active" ? "Deactivate" : "Activate",
                    controller: this,
                    click: () => {
                        if (entity.status == "Active")
                            this.deactivate(entity.entryNumber);
                        else if (entity.status == "Inactive")
                            this.activate(entity.entryNumber);
                    }
                },
                {
                    value: "Remove",
                    controller: this,
                    click: async () => {
                        if (await this.confirmRemoveQRCodeSetup(entity.name))
                            this.remove(entity.entryNumber);
                    },
                },
            ] as ButtonOption[];
        });
    }

    private edit(controller: LabelPreparationRegister, row: LabelPreparationSetup) {
        if (row.entryNumber) {
            controller.showLabelPreparationSetupModal = true;
            controller.labelPreparationSetup = LabelPreparationSetup.map(row);
            controller.isViewMode = false;
            controller.isEditMode = true;
            controller.labelPreparationSetupModalButton.nativeElement.click();
        }
    }

    private view(controller: LabelPreparationRegister, row: LabelPreparationSetup) {
        if (row.entryNumber) {
            controller.showLabelPreparationSetupModal = true;
            controller.labelPreparationSetup = LabelPreparationSetup.map(row);
            controller.isViewMode = true;
            controller.isEditMode = false;
            controller.labelPreparationSetupModalButton.nativeElement.click();
        }
    }

    private remove(entryNumber: number) {
        if (entryNumber > 0) {
            this.labelPreparationService
                .remove(entryNumber)
                .subscribe(
                    () => this.refreshTable(),
                    (err) => {
                        this.asyncModalService.getModalResponse(err.error);
                    }
                );
        }
    }

    private activate(entryNumber: number) {
        if (entryNumber > 0) {
            this.labelPreparationService
                .activate(entryNumber)
                .subscribe(
                    () => this.refreshTable(),
                    (err) => {
                        this.asyncModalService.getModalResponse(err.error);
                    }
                );
        }
    }

    private deactivate(entryNumber: number) {
        if (entryNumber > 0) {
            this.labelPreparationService
                .deactivate(entryNumber)
                .subscribe(
                    () => this.refreshTable(),
                    (err) => {
                        this.asyncModalService.getModalResponse(err.error);
                    }
                );
        }
    }

    private async confirmRemoveQRCodeSetup(qrCodeName) {
        return await this.asyncModalService.getModalResponse(
            "Are you sure you want to delete <b>" + qrCodeName + "</b> QR Code Setup?",
            [
                { label: "Yes", value: true },
                { label: "No", value: false },
            ]
        );
    }
}
